import "@babel/polyfill";

import Config from "./Config";
import Common from './Common';

require('./libs/daijima/trace.js');
require('./libs/daijima/requestanimationframe.js');

import "../scss/common.scss";
import "../scss/top.scss";
import "../scss/message.scss";
import "../scss/faq.scss";
import "../scss/voices.scss";
import "../scss/culture.scss";
import "../scss/job.scss";
import "../scss/requirements.scss";
import "../scss/entry.scss";
import "../scss/page404.scss";
import "../scss/voices.scss";

//CSS Modulesとして使用する場合
// import * as styles from "../scss/common.scss";

Config.getInstance();
new Common();

require('./barba-custom.js');